import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Activity, AlertCircle, Users, DollarSign, TrendingUp, ShieldAlert } from "lucide-react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

export default function DispatcherDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/analytics/dashboard").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="text-slate-500">Loading…</div>;

  const cards = [
    { label: "Open Requests", value: data.open_requests, icon: Activity, color: "#0B67C2" },
    { label: "Urgent / Emergency", value: data.urgent_requests, icon: AlertCircle, color: "#DC2626" },
    { label: "Available Now", value: data.available_now, icon: Users, color: "#16B3A8" },
    { label: "Fill Rate", value: `${data.fill_rate}%`, icon: TrendingUp, color: "#22C55E" },
    { label: "Revenue (CAD)", value: `$${data.revenue.toLocaleString()}`, icon: DollarSign, color: "#003A8C" },
    { label: "Credential Alerts", value: data.credential_alerts, icon: ShieldAlert, color: "#F59E0B" },
  ];

  return (
    <div className="space-y-8" data-testid="dispatcher-dashboard">
      <div>
        <h1 className="text-3xl font-bold text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>Dispatch Console</h1>
        <p className="text-slate-500 mt-1">Live operations overview across the NetStaff network.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <Card key={c.label} data-testid={`metric-${c.label.toLowerCase().replace(/\s/g, "-")}`}>
              <CardContent className="p-6">
                <div className="flex items-start justify-between">
                  <div>
                    <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">{c.label}</div>
                    <div className="mt-2 text-3xl font-bold text-brand-navy" style={{ fontFamily: "Outfit, sans-serif" }}>{c.value}</div>
                  </div>
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ background: `${c.color}15` }}>
                    <Icon className="w-6 h-6" style={{ color: c.color }} />
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card>
        <CardHeader><CardTitle>Top facilities by request volume</CardTitle></CardHeader>
        <CardContent>
          {data.top_facilities.length > 0 ? (
            <ResponsiveContainer width="100%" height={280}>
              <BarChart data={data.top_facilities}>
                <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
                <XAxis dataKey="facility" stroke="#64748B" fontSize={12} />
                <YAxis stroke="#64748B" fontSize={12} />
                <Tooltip />
                <Bar dataKey="requests" fill="#003A8C" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          ) : <div className="text-sm text-slate-500">No data yet</div>}
        </CardContent>
      </Card>
    </div>
  );
}
